import React, { useState, useRef } from "react";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

function AboutReviewSlider({ data }) {
  const datas = [
    {
      text: "Originally, creative and with an innate understanding of their customer’s need. The team at Miles are always a pleasure to work with. Recommended.",
      name: "Bobby Hanesto",
      role: "Director of",
      company: "Invisionapp",
      img: "https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp",
    },
    {
      text: "Originally, creative and with an innate understanding of their customer’s need. The team at Miles are always a pleasure to work with. Recommended.",
      name: "Bobby Hanesto",
      role: "Director of",
      company: "Invisionapp",
      img: "https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp",
    },
    {
      text: "Originally, creative and with an innate understanding of their customer’s need. The team at Miles are always a pleasure to work with. Recommended.",
      name: "Bobby Hanesto",
      role: "Director of",
      company: "Invisionapp",
      img: "https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp",
    },
    {
      text: "Originally, creative and with an innate understanding of their customer’s need. The team at Miles are always a pleasure to work with. Recommended.",
      name: "Bobby Hanesto",
      role: "Director of",
      company: "Invisionapp",
      img: "https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp",
    },
    {
      text: "Originally, creative and with an innate understanding of their customer’s need. The team at Miles are always a pleasure to work with. Recommended.",
      name: "Bobby Hanesto",
      role: "Director of",
      company: "Invisionapp",
      img: "https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp",
    },
    {
      text: "Originally, creative and with an innate understanding of their customer’s need. The team at Miles are always a pleasure to work with. Recommended.",
      name: "Bobby Hanesto",
      role: "Director of",
      company: "Invisionapp",
      img: "https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const touchStart = useRef(0);
  const touchEnd = useRef(0);

  // Swipe handling
  const handleTouchStart = (e) => {
    touchStart.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEnd.current = e.changedTouches[0].clientX;
    if (touchStart.current - touchEnd.current > 50) {
      handleNext(); // Swipe left (next)
    }
    if (touchStart.current - touchEnd.current < -50) {
      handlePrev(); // Swipe right (prev)
    }
  };

  // Prev and Next slide handlers
  const handlePrev = () => {
    setCurrentIndex(currentIndex === 0 ? datas.length - 1 : currentIndex - 1);
  };

  const handleNext = () => {
    setCurrentIndex(currentIndex === datas.length - 1 ? 0 : currentIndex + 1);
  };

  return (
    <div className="bg-white w-full h-[450px]">
      <div
        className="relative bg-cover bg-center h-[400px] sm:h-[500px] md:h-[250px] lg:h-[300px]"
        style={{ backgroundImage: "url('./assets/bg3.webp')" }}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {/* Background Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        {/* Slider Content */}
        <div className="relative container mx-auto flex items-center justify-center h-full px-4">
          {/* Navigation Arrows for LG and MD screens */}
          <div className="absolute max-w-4xl hidden lg:flex items-center justify-between w-full hidden md:block">
            <button
              onClick={handlePrev}
              className=" w-16 h-16 p-2 transform -translate-y-1/2 hover:opacity-50 border-2 border-yellow-400 text-white rounded-full shadow-lg hidden md:block  "
            >
              <span className="text-lg font-bold text-yellow-400">
                &#10094;
              </span>
            </button>
            <button
              onClick={handleNext}
              className=" w-16 h-16 p-2 transform -translate-y-1/2 hover:opacity-50 border-2 border-yellow-400 text-white rounded-full shadow-lg hidden md:block  "
            >
              <span className="text-lg font-bold text-yellow-400">
                &#10095;
              </span>
            </button>
          </div>

          <div className="w-full max-w-4xl overflow-hidden  shadow-lg rounded-lg lg:mt-[16%] md:mt-[12%] mt-0">
            <div
              className="flex transition-transform duration-500"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {data?.map((data, index) => (
                <div
                  key={index}
                  className="min-w-full sm:w-1/2 lg:w-1/3 p-8 text-center bg-white rounded-lg shadow-md"
                >
                  <p className="text-gray-600 italic mb-4">{data?.review}</p>
                  <div className="flex items-center justify-center">
                    <img
                      src="https://carrgohtml.tortoizthemes.com/assets/images/client-1.webp"
                      alt={data?.user_name}
                      className="w-12 h-12 rounded-full border-2 border-gray-300"
                    />
                    <div className="ml-4 text-left">
                      <h3 className="font-bold text-gray-800">
                        {data?.user_name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {Array.from({ length: 5 }, (_, i) =>
                          i < (data?.rating || 0) ? (
                            <StarIcon key={i} className="text-yellow-400" />
                          ) : (
                            <StarBorderIcon key={i} className="text-gray-400" />
                          )
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Arrows for LG and MD screens */}
            {/* <button
              onClick={handlePrev}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-yellow-500 hover:bg-yellow-600 text-white p-3 rounded-full shadow-lg hidden md:block"
            >
              &#10094;
            </button>
            <button
              onClick={handleNext}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-yellow-500 hover:bg-yellow-600 text-white p-3 rounded-full shadow-lg hidden md:block"
            >
              &#10095;
            </button> */}

            {/* Dots for SM or mobile screens */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 md:hidden">
              {data?.map((_, index) => (
                <span
                  key={index}
                  className={`h-2 w-2 rounded-full bg-white ${
                    currentIndex === index ? "bg-yellow-500" : "bg-gray-400"
                  }`}
                  onClick={() => setCurrentIndex(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutReviewSlider;
